import { Hash, Clock, Lightbulb } from "lucide-react";

export default function MetadataSidebar({ seo = {}, bestPostTime, growthTips = [] }) {
  return (
    <div className="space-y-4">
      <div className="border border-white/10 rounded-md bg-[#121212] p-5">
        <h3 className="font-head font-semibold mb-3 flex items-center gap-2">
          <Hash className="h-4 w-4 text-blue-400" /> SEO & metadata
        </h3>
        {seo?.description && <p className="text-sm text-zinc-400 mb-3">{seo.description}</p>}
        {seo?.thumbnail_text && (
          <div className="mb-3">
            <p className="text-xs text-zinc-500 mb-1">Thumbnail text</p>
            <p className="text-sm font-head font-bold">{seo.thumbnail_text}</p>
          </div>
        )}
        {seo?.hashtags?.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {seo.hashtags.map((h, i) => (
              <span key={h} className="text-xs bg-white/5 border border-white/10 rounded-full px-2 py-0.5 text-zinc-300">
                {h}
              </span>
            ))}
          </div>
        )}
      </div>

      {bestPostTime && (
        <div className="border border-white/10 rounded-md bg-[#121212] p-5">
          <h3 className="font-head font-semibold mb-2 flex items-center gap-2">
            <Clock className="h-4 w-4 text-blue-400" /> Best time to post
          </h3>
          <p className="text-sm text-zinc-300">{bestPostTime}</p>
        </div>
      )}

      {growthTips?.length > 0 && (
        <div className="border border-white/10 rounded-md bg-[#121212] p-5">
          <h3 className="font-head font-semibold mb-3 flex items-center gap-2">
            <Lightbulb className="h-4 w-4 text-blue-400" /> Growth tips
          </h3>
          <ul className="space-y-2">
            {growthTips.map((t, i) => (
              <li key={t} className="text-sm text-zinc-400 flex gap-2">
                <span className="text-blue-400">{i + 1}.</span> {t}
              </li>
            ))}
          </ul>
        </div>
      )}

      {seo?.tags?.length > 0 && (
        <div className="border border-white/10 rounded-md bg-[#121212] p-5">
          <h3 className="font-head font-semibold mb-2 text-sm">Tags</h3>
          <p className="text-xs text-zinc-500 leading-relaxed">{seo.tags.join(", ")}</p>
        </div>
      )}
    </div>
  );
}
